import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Heading,
    Text,
    Button,
    useBreakpointValue,
    Flex
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {LeftArrow} from '../icons'
import { ErrorIcon } from '../icons'

const MaintenancePage = ({title, message, orderHistory = false}) => {
    const history = useHistory()
    const styles = useMultiStyleConfig('OrderHistory')
    const isMobile = useBreakpointValue({base: true, md: false})
    const isOrderHistory = orderHistory

    return (
        <Box {...styles.maintenanceContentWrapper}>
            {isMobile && !isOrderHistory && (
                <Button mb="32px" variant="link" onClick={() => history.push('/account')}>
                    <LeftArrow />
                </Button>
            )}
            {isOrderHistory ? (
                <Flex {...styles.maintenanceTitleContainer}>
                    <ErrorIcon {...styles.maintenanceIndicatorIcon} boxSize={5} />
                    <Heading {...styles.maintenanceTitle}>{title}</Heading>
                </Flex>
            ) : (
                <Heading as="h1" fontSize="24px" mb={4} textAlign="left" textTransform="uppercase">
                    {title}
                </Heading>
            )}

            <Text
                fontFamily="GarageNeue"
                mb={{base: isOrderHistory ? 0 : '345px', lg: isOrderHistory ? 0 : 10}}
                width={{
                    base: isOrderHistory ? '85%' : '100%',
                    lg: isOrderHistory ? '100%' : '100%'
                }}
                fontSize={{base: isOrderHistory ? '12px' : '', lg: isOrderHistory ? '14px' : ''}}
                textAlign="left"
            >
                {message}
                {' '}
                {isOrderHistory && (
                    <Button
                        variant="link"
                        colorScheme="blue"
                        onClick={() => history.push('/')}
                        {...styles.noOrdersActionButton}
                    >
                        <FormattedMessage
                            defaultMessage="Continue Shopping."
                            id="maintenance_page.shopping.cta"
                        />
                    </Button>
                )}
            </Text>

            {!isOrderHistory && (
                <Button
                    variant="solid"
                    colorScheme="blue"
                    onClick={() => history.push('/')}
                    textAlign="left"
                    fontSize="md"
                >
                    <FormattedMessage
                        defaultMessage="Continue Shopping."
                        id="maintenance_page.shopping.cta"
                    />
                </Button>
            )}
        </Box>
    )
}

MaintenancePage.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    orderHistory: PropTypes.string
}

export default MaintenancePage
